import { FC } from 'react';
import styles from './TransferItemsForm.module.scss'
import { Checkbox, FormControlLabel } from '@mui/material';
import { ITable } from '../../../../modules/consume/domain/models/ITables';

interface ITransferItemsFormTableProps {
    table: ITable;
    onChange: (selectedTable: ITable) => void;
    selectedTable?: ITable;
}

export const TransferItemsFormTable: FC<ITransferItemsFormTableProps> = ({ table, onChange, selectedTable }) => {
    return (
        <div id={styles.TransferItemsFormTable}>
            <FormControlLabel
                checked={table.id === selectedTable?.id}
                onChange={(ev) => onChange(table)}
                control={<Checkbox />}
                label={<div className={styles.header}>{table.number ?? table.cardTag}</div>}
            />
            {table.cardTag 
                ? <img src='/assets/img/debit-card.svg' alt='Comanda' /> 
                : !!table.openedAt && !table.startClosingAt 
                    ? <img src='/assets/img/table-type-icon-secondary.svg' alt='Mesa aberta' />
                    : <img src='/assets/img/table-type-icon.svg' alt='Mesa fechada' />
            }
        </div>
    );
};
